import { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Logo from "../../assets/images/logo.png";
import useCurrentUser from "hooks/useCurrentUser";
import { scroller } from "react-scroll";
import { authService } from "services";
import profileImg from "../../assets/images/profile.svg";
import { CiLogout } from "react-icons/ci";
import "./style.scss";
import LogoutModal from "components/Modals/Alertpopus/Logout";

const SCROLL_OPTIONS = {
  smooth: "easeInOutQuart",
  duration: 700,
  offset: -100, // sticky header height
};

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [isLogout, setLogout] = useState(false);

  const { user, setUser } = useCurrentUser();
  const navigate = useNavigate();
  const location = useLocation();

  /* ---------------- LOGOUT ---------------- */
  const handleLogout = async () => {
    try {
      await authService.logout();
      localStorage.clear();
      setUser(null);
      navigate("/login");
    } catch (err) {
      console.log(err);
    }
  };

  /* ---------------- NAV ITEMS ---------------- */
  const navItems = [
    { label: "Home", path: "/" },
    { label: "About Us", section: "about-company" },
    { label: "How It Works", section: "how-it-work" },
    { label: "FAQ's", section: "faq-new-section" },
  ];

  /* ---------------- SCROLL HANDLER ---------------- */
  const scrollToSection = (section) => {
    setIsMenuOpen(false);

    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: section } });
    } else {
      requestAnimationFrame(() => {
        scroller.scrollTo(section, SCROLL_OPTIONS);
      });
    }
  };

  /* ---------------- SCROLL AFTER NAVIGATION ---------------- */
  useEffect(() => {
    if (location.pathname === "/" && location.state?.scrollTo) {
      requestAnimationFrame(() => {
        scroller.scrollTo(location.state.scrollTo, SCROLL_OPTIONS);
      });
    }
  }, [location]);

  /* ---------------- CLOSE MENU ON ROUTE CHANGE ---------------- */
  useEffect(() => {
    setIsMenuOpen(false);
  }, [location.pathname]);

  /* ---------------- STICKY HEADER ---------------- */
  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };
    handleScroll();
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  /* ---------------- RENDER ---------------- */
  return (
    <>
      <header
        className={`header-bar ${isMenuOpen ? "menu-open" : ""} ${isSticky ? "sticky" : ""
          }`}
      >
        <div className="header-inner container">
          {/* LEFT NAV */}
          <ul
            id="primary-navigation"
            className={`nav-left ${isMenuOpen ? "is-open" : ""}`}
          >
            {navItems.map((item, index) => (
              <li key={index} className="nav-item">
                {item.section ? (
                  <button
                    type="button"
                    className="nav-link"
                    onClick={() => scrollToSection(item.section)}
                  >
                    {item.label}
                  </button>
                ) : (
                  <Link to={item.path} className="nav-link">
                    {item.label}
                  </Link>
                )}
              </li>
            ))}
          </ul>

          {/* LOGO */}
          <Link to="/" className="brand">
            <img src={Logo} alt="Logo" />
          </Link>

          {/* RIGHT NAV */}
          <div className="nav-right">
            <button
              type="button"
              aria-label="Toggle navigation"
              aria-expanded={isMenuOpen}
              className={`menu-toggle ${isMenuOpen ? "active" : ""}`}
              onClick={() => setIsMenuOpen((prev) => !prev)}
            >
              <span className="bar"></span>
              <span className="bar"></span>
              <span className="bar"></span>
            </button>

            <Link to="/advertise" className="advertise-link">
              Advertise with us!
            </Link>
            <Link to="/contact" className="advertise-link">
              Contact Us
            </Link>

            {user?.baseS3Url ? (
              <div className="user-controls">
                <Link to="/my-profile">
                  <img
                    className="avatar"
                    src={`${user.baseS3Url}${user.avatar || ""}`}
                    alt="User Avatar"
                    onError={(e) => {
                      e.currentTarget.onerror = null;
                      e.currentTarget.src = profileImg;
                    }}
                  />
                </Link>

                <button
                  type="button"
                  className="logout-btn"
                  onClick={() => setLogout(true)}
                >
                  <CiLogout size={18} />
                  <span>Logout</span>
                </button>
              </div>
            ) : (
              <Link to="/login" className="login-btn">
                Login Here
              </Link>
            )}
          </div>
        </div>
      </header>

      <LogoutModal
        show={isLogout}
        handleClose={() => setLogout(false)}
        handleConfirm={handleLogout}
      />
    </>
  );
};

export default Header;
